// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   ShareModal — 강의실 단위 공유 토글 모달 (도메인 중립, 재사용 컴포넌트)
   사용처: features/mcp/McpList, features/prompt/PromptList, features/agent/AgentList
   ======================================================================== */

.share-modal__overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: shareModalFade 0.18s ease-out;
}

@keyframes shareModalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.share-modal {
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: shareModalSlide 0.2s ease-out;
}

@keyframes shareModalSlide {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.share-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 0 0 12px;
  border-bottom: 1px solid var(--fg-line);
}

.share-modal__title {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  margin: 0;
}

.share-modal__close {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.share-modal__close:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.share-modal__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.share-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}

.share-modal__intro {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.share-modal__target-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.share-modal__desc {
  font-size: 14px;
  color: var(--fg-text-basic);
  margin: 0;
  line-height: 1.5;
}

.share-modal__class-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.share-modal__class-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 12px 12px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: var(--transition-fast);
}

.share-modal__class-item:hover,
.share-modal__class-item--selected {
  border-color: var(--fg-text-basic);
  background: #fff;
}

.share-modal__check {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  border-radius: 4px;
  background: #c2c2c2;
  display: grid;
  place-items: center;
  transition: var(--transition-fast);
}

.share-modal__check--on {
  background: var(--fg-side-hover);
}

.share-modal__class-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.share-modal__class-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-modal__class-date {
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

.share-modal__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  font-size: 13px;
  color: var(--fg-text-gray);
  text-align: center;
}

.share-modal__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 0 0;
}

.share-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 12px;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
}

.share-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.share-modal__btn--save {
  background: var(--fg-button);
}

.share-modal__btn--save:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.share-modal__btn--cancel {
  background: var(--fg-text-gray);
}

.share-modal__btn--cancel:hover:not(:disabled) {
  filter: brightness(0.95);
}
`, "",{"version":3,"sources":["webpack://./src/css/ShareModal.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* ========================================================================\n   ShareModal — 강의실 단위 공유 토글 모달 (도메인 중립, 재사용 컴포넌트)\n   사용처: features/mcp/McpList, features/prompt/PromptList, features/agent/AgentList\n   ======================================================================== */\n\n.share-modal__overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: shareModalFade 0.18s ease-out;\n}\n\n@keyframes shareModalFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.share-modal {\n  width: 100%;\n  max-width: 520px;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: shareModalSlide 0.2s ease-out;\n}\n\n@keyframes shareModalSlide {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.share-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 0 0 12px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.share-modal__title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  margin: 0;\n}\n\n.share-modal__close {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.share-modal__close:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.share-modal__close:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.share-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 0;\n}\n\n.share-modal__intro {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.share-modal__target-name {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.share-modal__desc {\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.share-modal__class-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.share-modal__class-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 12px 12px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: var(--transition-fast);\n}\n\n.share-modal__class-item:hover,\n.share-modal__class-item--selected {\n  border-color: var(--fg-text-basic);\n  background: #fff;\n}\n\n.share-modal__check {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  border-radius: 4px;\n  background: #c2c2c2;\n  display: grid;\n  place-items: center;\n  transition: var(--transition-fast);\n}\n\n.share-modal__check--on {\n  background: var(--fg-side-hover);\n}\n\n.share-modal__class-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.share-modal__class-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.share-modal__class-date {\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n.share-modal__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n.share-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 0 0;\n}\n\n.share-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 12px;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.share-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.share-modal__btn--save {\n  background: var(--fg-button);\n}\n\n.share-modal__btn--save:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.share-modal__btn--cancel {\n  background: var(--fg-text-gray);\n}\n\n.share-modal__btn--cancel:hover:not(:disabled) {\n  filter: brightness(0.95);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
